import { connect } from 'react-redux';
import { keyBy, get } from 'lodash/fp';
import playerPositionsSelector from '../../selectors/playerPositionsSelector';
import teamPositionsSelector from '../../selectors/teamPositionsSelector';
import salaryExpenditureSelector from '../../selectors/salaryExpenditureSelector';
import { makeInitials, makePositionStr } from '../../utils/playerUtils';
import OpenEntityRow from './OpenEntityRow';

function mapStateToProps(state, { player, competitionId, isRacing, isTeam }) {
  const challenge = state.rapidfire.upcomingChallenges.find(c => c.competitionId === competitionId);
  const positions = isTeam ? teamPositionsSelector(state) : playerPositionsSelector(state);
  const { average, form, salary, weight, winProjected, placeProjected, popularity } = player;

  return {
    awayTeam: player.awayAbbr,
    barrier: player.barrier,
    canAfford: player.salary <= get(challenge, 'salaryCap') - salaryExpenditureSelector(state),
    homeTeam: player.homeAbbr,
    image: player.imageURI,
    rider: player.rider,
    riderImage: player.riderImage,
    initials: makeInitials(player.name),
    isHome: player.isHome,
    isRacing,
    isScratched: player.isScratched,
    labels: player.labels,
    name: player.name,
    playerSelectionTableInfo: get(challenge, 'playerSelectionTableInfo'),
    positionStr: makePositionStr(keyBy('id', positions))(player.positions),
    positions: player.positions,
    reverseOrder: player.reverseOrder,
    trainer: player.trainer,
    tableData: {
      average,
      form,
      salary,
      weight,
      winProjected,
      placeProjected,
      popularity
    },
    teamName: player.teamName
  };
}

const WidgetEntityRow = connect(mapStateToProps)(OpenEntityRow);

export default WidgetEntityRow;
